module.exports = __webpack_public_path__ + "30f9433d2028d92e7d2675392fd099ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_25.jpg
// module id = 1738
// module chunks = 5